import img from '../../assets/images-sites/images.jpg';
import './CommunitySection.css';

const CommunitySection = () => {
    return (
        <section className="community-site-section py-5" id="communaute">
            <div className="container py-lg-5">
                <div className="row g-5 align-items-center flex-column-reverse flex-lg-row">
                    {/* Images à gauche */}
                    <div className="col-lg-6">
                        <div className="community-img-stack position-relative d-flex justify-content-center">
                            <div className="img-c-1 w-75 shadow-2xl rounded-4 overflow-hidden border border-4 border-white">
                                <img src="https://images.unsplash.com/photo-1511632765486-a01980e01a18?q=80&w=400" alt="group" className="w-100 h-100 object-cover" />
                            </div>
                            <div className="img-c-2 w-50 position-absolute bottom-0 start-0 mb-n4 ms-n4 shadow-2xl rounded-4 overflow-hidden border border-4 border-white animate__animated animate__fadeInUp">
                                <img src={img} alt={img} className="w-100 h-100 object-cover" />
                            </div>
                        </div>
                    </div>

                    {/* Texte à droite */}
                    <div className="col-lg-6">
                        <div className="community-content ps-lg-5">
                            <span className="text-success fw-bold text-uppercase tracking-widest small mb-2 d-block">
                                Communauté
                            </span>
                            <h2 className="section-c-title outfit fs-1 fw-bold text-dark mb-4">Plus qu'une mission, une famille</h2>
                            <p className="text-muted fs-5 mb-4">
                                Nous croyons en la puissance de l'unité et de la fraternité chrétienne. Notre communauté est un lieu où chacun peut trouver refuge, soutien et épanouissement spirituel.
                            </p>
                            
                            <ul className="community-features list-unstyled mb-5">
                                <li className="mb-3 d-flex align-items-center gap-3">
                                    <div className="icon-box bg-success bg-opacity-10 text-success rounded-circle p-2">
                                        <i className="bi bi-people-fill"></i>
                                    </div>
                                    <span className="fw-bold">Groupes de prière hebdomadaires</span>
                                </li>
                                <li className="mb-3 d-flex align-items-center gap-3">
                                    <div className="icon-box bg-success bg-opacity-10 text-success rounded-circle p-2">
                                        <i className="bi bi-chat-heart-fill"></i>
                                    </div>
                                    <span className="fw-bold">Soutien spirituel personnalisé</span>
                                </li>
                                <li className="mb-3 d-flex align-items-center gap-3">
                                    <div className="icon-box bg-success bg-opacity-10 text-success rounded-circle p-2">
                                        <i className="bi bi-calendar-check-fill"></i>
                                    </div>
                                    <span className="fw-bold">Évènements et partages communautaires</span>
                                </li>
                            </ul>

                            <button className="btn btn-outline-success rounded-pill px-4 py-2 fw-bold">
                                REJOINDRE LA COMMUNAUTÉ
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CommunitySection;
